(() => {
  'use strict';
  const config=window.JAMR_SHOP;
  const locale=String(config.locale||'en').split('-')[0].toLowerCase()==='ar'?'ar':'en';
  const dictionary=locale==='ar'?{'ADD TO BAG':'إضافة إلى السلة','VIEW PRODUCT':'عرض العطر','PRE-ORDER':'طلب مسبق','Change language':'تغيير اللغة'}:{};
  const canonical=new Map(Object.keys(dictionary).map(k=>[k.trim().toLowerCase(),k]));
  const missing=new Set();
  const t=value=>{
    const text=String(value??'');
    if(dictionary[text]!==undefined)return dictionary[text];
    const key=canonical.get(text.trim().toLowerCase());
    if(key!==undefined){const result=dictionary[key];return (text.match(/^\s*/)?.[0]||'')+result.trim()+(text.match(/\s*$/)?.[0]||'');}
    if(text.trim()&&!/^[\s·0-9/]+$/.test(text))missing.add(text);
    return text;
  };
  config.root=String(config.root||'/').replace(/\/?$/,'/');
  const asset=path=>config.assets[path]||path;
  const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const families={citrus:'Fresh & Citrus',rose:'Floral',jasmine:'Floral',iris:'Floral',white_flowers:'Floral',oud:'Woody',sandalwood:'Woody',patchouli:'Woody',amber:'Amber & Spice',spices:'Amber & Spice',saffron:'Amber & Spice',musk:'Soft & Musky',vanilla:'Sweet & Gourmand',leather:'Rich & Smoky',tobacco:'Rich & Smoky',frankincense:'Rich & Smoky'};
  const data=window.JAMR_DATA,catalog=window.JAMR_NOTE_CATALOG;
  for(const note of catalog.notes){note.image=asset(note.image);data.ingredientByKey[note.key].image=note.image;}
  data.products=data.products.filter(p=>window.JAMR_COM_PRODUCTS[p.id]);
  window.JAMR_CART={};
  for(const p of data.products){const target=window.JAMR_COM_PRODUCTS[p.id];window.JAMR_CART[p.id]={handle:target.handle,available:false,variantId:null,preorder:target.preorder};}
  const summary=product=>escape(window.JAMR_SUMMARIES[locale]?.[product.id]||product.summary);
  const title=product=>escape((locale==='ar'?window.JAMR_COM_PRODUCTS[product.id]?.titleAr:product.title)||product.title).replace(/ Perfume$/i,'');
  const requests=new Map();
  function hydrate(product,state){
    if(requests.has(product.id))return requests.get(product.id);
    const target=window.JAMR_CART[product.id];
    const request=fetch(config.root+'products/'+encodeURIComponent(target.handle)+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(response=>{if(!response.ok)throw new Error('Product unavailable');return response.json();})
      .then(live=>{
        const expected=window.JAMR_COM_PRODUCTS[product.id].id.split('/').pop();
        if(String(live.id)!==expected)throw new Error('Product identity mismatch');
        const variants=live.variants||[];
        target.available=!target.preorder&&variants.length===1&&variants[0].available===true&&!live.requires_selling_plan;
        target.variantId=target.available?String(variants[0].id):null;
        refreshPurchase(product,state);
      }).catch(()=>{target.available=false;target.variantId=null;});
    requests.set(product.id,request);return request;
  }
  function refreshPurchase(product,state){
    const target=window.JAMR_CART[product.id];
    const detail=state.screen==='detail'&&state.detail?.id===product.id;
    const result=state.screen==='result'&&state.result?.some(item=>item.id===product.id);
    if(!detail&&!result)return;
    const scope=detail?document.querySelector('.detail-actions'):document.querySelector('.product-card[data-product="'+product.id+'"]');
    const old=scope?.querySelector('a.cart-add');
    if(old&&target.preorder)old.textContent=t('PRE-ORDER');
    if(!old||!target.available||!target.variantId)return;
    const form=document.createElement('form');form.className='cart-add-form'+(detail?' detail-cart-form':'');form.method='post';form.action=config.root+'cart/add';form.dataset.cartForm=product.id;
    form.dataset.cartSource=detail?'product_detail':'results';
    for(const [name,value] of Object.entries({form_type:'product',utf8:'✓',id:target.variantId,quantity:1,return_to:config.root+'cart'})){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}
    const button=document.createElement('button');button.type='submit';button.className='cart-add'+(detail?' detail-cart':'');button.textContent=t('ADD TO BAG');form.append(button);old.replaceWith(form);
  }
  function afterRender(state){
    document.documentElement.lang=locale;document.documentElement.dir=locale==='ar'?'rtl':'ltr';
    const selector=document.querySelector('#preview-language');
    if(selector){selector.value=config.locale;selector.setAttribute('aria-label',t('Change language'));}
    const pending=state.screen==='result'?state.result:state.screen==='detail'&&state.detail?[state.detail]:[];
    for(const p of pending){hydrate(p,state);refreshPurchase(p,state);}
  }
  document.getElementById('preview-language').addEventListener('change',event=>{
    const form=event.currentTarget.form;
    if(form&&Array.from(event.currentTarget.options).some(option=>option.value===event.currentTarget.value))form.requestSubmit();
  });
  window.JAMR_I18N={locale,t,asset,title,summary,afterRender,missing,family:key=>t(families[key]||'Woody'),pendingProducts:()=>Promise.all(requests.values())};
  document.documentElement.lang=locale;document.documentElement.dir=locale==='ar'?'rtl':'ltr';
})();
